import queryString from "query-string";

class UrlManagement {
  constructor() {}
  manage(param) {
    let currentUrlParams = this.getParsedUrl();
    if (this.paramExist(param)) {
      delete currentUrlParams[_.keys(param)[0]];
      let newUrl = `${this.getUrl()}?${queryString.stringify(currentUrlParams)}`;
      this.setUrl(newUrl);
    } else {
      if (history.pushState) {
        currentUrlParams[_.keys(param)[0]] = param[_.keys(param)[0]];
        let newUrl = `${this.getUrl()}?${queryString.stringify(currentUrlParams)}`;
        this.setUrl(newUrl);
      }
    }
  }

  manageSortParams(params) {
    let currentUrlParams = this.getParsedUrl();
    currentUrlParams["sortBy"] = params["sortBy"];
    currentUrlParams["sortType"] = params["sortType"];
    let newUrl = `${this.getUrl()}?${queryString.stringify(currentUrlParams)}`;
    this.setUrl(newUrl);
  }

  paramExist(param) {
    let paramKeys = _.keys(this.getParsedUrl());
    return _.includes(paramKeys, _.keys(param)[0]);
  }

  setUrl(url) {
    window.history.pushState({ path: url }, "", url);
  }

  clearUrl() {
    window.history.pushState({ path: this.getUrl() }, "", this.getUrl());
  }

  getUrl() {
    return `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  }

  getParsedUrl() {
    return queryString.parse(location.search);
  }

  hasFiltersApplied() {
    return !_.isEmpty(this.getParsedUrl());
  }
}

export default UrlManagement;
